import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resetuje pozycję scrolla na górę przy zmianie ścieżki (SPA — react-router
 * domyślnie zachowuje scroll). Pomija nawigację z hashem (#kotwica), żeby nie
 * psuć przewijania do sekcji. Musi być wewnątrz <BrowserRouter>.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // kotwica → pozwól przeglądarce przewinąć do elementu
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
